// extracted by mini-css-extract-plugin
export var navbarSubLink = "S_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "S_xS d_f0 d_dB";
export var subPageLink = "S_gf d_gf";
export var burger = "S_xW";
export var sublinkSize = "S_xX";
export var linkSize = "S_xY";
export var Link = "S_vs G_vs G_tV G_vd";